export enum Notes {
  MonthlyReviewNotes = 'Monthly Review Notes',
  TaskInstructions = 'Task Instructions',
}
